export enum Branding {
  TURCK_BANNER = 'turckBanner',
  DEFAULT = 'default',
}
